import script from "./EstimateBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./EstimateBadge.vue?vue&type=script&lang=ts&setup=true"

import "./EstimateBadge.vue?vue&type=style&index=0&id=b532729a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b532729a"]])

export default __exports__